import api from 'data/api';

export const loadNetworks = api('GET /api/mobile/lookups/networks');
